<div class="organization-modal modal-content" piqetAngularDraggable>
  <ng-container>
    <div class="modal-header header-modal">
      <span class="bootstrap-dialog-title header-title">{{ modalLabel }}</span>
      <button type="button" aria-label="Close" class="closeModal pull-right" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>

    <div class="modal-body body-modal">
      <form [formGroup]="scenarioCopyForm">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                formControlName="projectName"
                [control]="scenarioCopyForm.get('projectName')"
                label="Scenario name"
                placeholder="Scenario name"
                [maxLength]="50"
                [submitted]="submitted"
                (customBlur)="getScenarioName($any(scenarioCopyForm.get('projectName')?.value))"
              >
              </piqet-angular-common-input>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                formControlName="projectNameForReport"
                [control]="scenarioCopyForm.get('projectNameForReport')"
                label="Scenario name used in report"
                placeholder="Scenario name used in report"
                [maxLength]="15"
                [submitted]="submitted"
              >
              </piqet-angular-common-input>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <div class="form-group required">
              <label *ngIf="scenarioCopyForm.get('status')?.value" class="sub-header-drpdown pb-2"
                >Status</label
              >
              <label
                *ngIf="
                  scenarioCopyForm.get('product')?.value && !scenarioCopyForm.get('status')?.value
                "
                class="placeholder-sub-header pb-2"
                >Holder_text</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #status
                [items]="statusItems"
                [searchable]="false"
                bindLabel="name"
                bindValue="id"
                formControlName="status"
                [searchFn]="commonInputSearch"
                placeholder="Status"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      class="form-control accordion-search search-input"
                      id="inputValidation"
                      placeholder="Search..."
                      (input)="status.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (submitted && scenarioCopyForm.controls['status']?.invalid) ||
                  (scenarioCopyForm.controls['status']?.touched &&
                    scenarioCopyForm.controls['status']?.invalid)
                "
                class="input-error"
              >
                Status is required.
              </div>
            </div>
          </div>

          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <div class="form-group">
              <label
                *ngIf="scenarioCopyForm.get('copyProject')?.value"
                class="sub-header-drpdown pb-2"
                >Selected project</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #copyProject
                [items]="copyProjects"
                [searchable]="false"
                bindLabel="name"
                formControlName="copyProject"
                [searchFn]="commonInputSearch"
                placeholder="Select Project"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      class="form-control accordion-search search-input"
                      id="inputValidation"
                      placeholder="Search..."
                      (input)="copyProject.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (submitted && scenarioCopyForm.controls['copyProject']?.invalid) ||
                  (scenarioCopyForm.controls['copyProject']?.touched &&
                    scenarioCopyForm.controls['copyProject']?.invalid)
                "
                class="input-error"
              >
                Project is required.
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer d-flex justify-content-start">
      <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
      <button type="button" class="modelBtn" (click)="onSave()">Save</button>
    </div>
  </ng-container>
</div>
